import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import api from "../Axios/api";
import { FileText, Pencil, Trash2, BookText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import Loader from "../common/Loader";
import ComputerPartsForm from "./ComputerParts.jsx";
const ReceiptNoteReport = () => {
  const userRole = useSelector((state) => state.user.staff_role);
  const auditor = useSelector((state) => state.user.staff_name);
  const currentStaffFacLoc = useSelector((state) => state.user.staff_FacLoc);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const navigation = useNavigate();
  const [data, setData] = useState([]);
  const [month, setMonth] = useState("");
  const [rowSelection, setRowSelection] = useState({});
  const [excelData, setExcelData] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [partsId, setPartsId] = useState(null);

  const [formData, setFormData] = useState([]);
  const [invoice, setInvoice] = useState("");
  const [vendor_id, setVendor_id] = useState("");
  const [receipt_id, setReceipt_id] = useState("");
  const [assetsDropdown, setAssetsDropdown] = useState([]);
  const [staffNameDropdown, setStaffNameDropdown] = useState([]);
  const [facLocation, setFacLocation] = useState([]);
  const branchMapping = {
    "666c0f5ebeca5ab2c65b2c85": "INSULATION",
    "666c0f5ebeca5ab2c65b2c86": "PROJECT",
    "666c0f5ebeca5ab2c65b2c87": "ROCKFIBRE",
  };

  const [active, setActive] = useState(() => {
    return userRole === "666c0f8ebeca5ab2c65b35a9"
      ? "ALL"
      : branchMapping[currentStaffFacLoc];
  });

  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(`/receipt-note/get?month=${month}`);
      const sortedData = res.data.sort((a, b) => b.receipt_no - a.receipt_no);
      setData(sortedData);
      // console.log(sortedData)
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getDetailsForExcel = async () => {
    try {
      const selectedIds = table
        .getSelectedRowModel()
        .rows.map((row) => row.original._id);
      // console.log(selectedIds)
      const res = await Promise.all(
        selectedIds.map(
          async (id) =>
            (
              await api.get(`receipt-note/get-excel-details/${id}`)
            ).data
        )
      );
      const allData = res.flat();
      const ascendingData = allData.sort((a, b) => Number(a.receipt_no) - Number(b.receipt_no));
      setExcelData(ascendingData);
      // console.log("excel", allData);
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDetailsForExcel();
  }, [rowSelection]);

  const assetsList = async () => {
    await api
      .get(`/receipt-note/computer-parts-area`)
      .then((res) => {
        const newData = res.data.map((item, index) => {
          return { value: item.assets_loca_id, label: item.assets_loca_name };
        });
        setAssetsDropdown(newData);
      })
      .catch((err) => console.log(err));
  };
  const staffNameList = async () => {
    await api
      .get(`/staff/get-staff-name`)
      .then((res) => {
        const newData = res.data.map((staff, index) => {
          return { value: staff._id, label: staff.staff_name };
        });
        setStaffNameDropdown(newData);
      })
      .catch((err) => console.log(err));
  };
  const facLocHandler = async () => {
    await api
      .get(`/factory-location/get-factory-location`)
      .then((res) => {
        const newData = res.data.map((location) => ({
          value: location._id,
          label: location.fectory_loca_name,
        }));
        setFacLocation(newData);
      })
      .catch((err) => console.log(err));
  };
  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this GRN.. ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.delete(`/receipt-note/delete/${row}`);
        // console.log("delete", response);

        if (response && response.status === 201) {
          Swal.fire({
            title: "Deleted!",
            text: "GRN Data deleted successfully!",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });

          getData();
        }
      } catch (error) {
        console.error("Error deleting data:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while deleting the data.",
          icon: "error",
        });
      }
    }
  };

  const handlePrint = (cell) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = `https://purchase24.polybonderps.site/purchase-print/receipt-print.php`;
    form.target = "_blank";

    const receiptId = document.createElement("input");
    receiptId.type = "hidden";
    receiptId.name = "receiptId";
    receiptId.value = cell.getValue();
    form.appendChild(receiptId);

    const dataInput = document.createElement("input");
    dataInput.type = "hidden";
    dataInput.name = "token";
    dataInput.value = JSON.stringify(Cookies.get("access_token"));
    form.appendChild(dataInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };


  const handleDynamicChange = (e, index) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = [...prev];

      updated[index][name] = value;

      if (name === "serialNumber") {
        updated[index].warranty = "1 Year";
      }

      return updated;
    });
  };


  const computerDetails = async (receiptId) => {
    try {
      const { data: printDetails } = await api.get(
        `/receipt-note/get-print-detail/${receiptId}`
      );
      const receiptInfo = printDetails[0];
      const rawItems = receiptInfo.receipt_item_info || [];
      setVendor_id(receiptInfo.party_id);
      setReceipt_id(receiptInfo._id);
      setInvoice(receiptInfo.challan_no);
      setSelectedRow(rawItems);
      let existingParts = null;

      try {
        const { data: computerPartsData } = await api.get(
          `/receipt-note/computer-parts-details/${receiptId}`
        );
        existingParts = computerPartsData?.items || null;
        setPartsId(computerPartsData._id);
        setIsEditMode(true);
      } catch (err) {
        if (err.response?.status === 404) {
          console.warn("Parts not found — will trigger ADD API later.");
          setIsEditMode(false);
          setPartsId(null);
        } else {
          throw err;
        }
      }

      if (Array.isArray(existingParts) && existingParts.length > 0) {
        const initial = existingParts.map((item) => ({
          itemId: item.item,
          qty: item.qty,
          ITStockQty: item.ITStockQty,
          rate: item.rate,
          serialNumber: item.serialNumber,
          user: item.user,
          factory: item.factory,
          area: item.area,
          remark: item.remark,
          status: item.status,
          invoiceNumber: item.invoiceNumber,
          warranty: item.warranty,
          warrantyExpiry: item.warrantyExpiry,
        }));
        setFormData(initial);
      } else {
        const initial = rawItems.map((item) => ({
          itemId: item.receipt_item_id,
          qty: item.receipt_item_qty,
          rate: item.receipt_item_rate,
          invoiceNumber: receiptInfo.challan_no || "",
          serialNumber: "",
          status: "",
          ITStockQty: 0,
          user: [],
          factory: [],
          area: [],
          warranty: "No warranty",
          warrantyExpiry: "",
          remark: "",
        }));
        setFormData(initial);
      }
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error in computerDetails():", error);
    }
  };

  const buttons =
    userRole === "666c0f8ebeca5ab2c65b35a9" ||
      auditor === "PolyBond Audit"
      ? ["ALL", "INSULATION", "PROJECT", "ROCKFIBRE"]
      : [branchMapping[currentStaffFacLoc]].filter(Boolean);

  const filteredData = useMemo(() => {
    let result = data;

    if (userRole === "666c0f8ebeca5ab2c65b35a9" || userRole === "666c0f8ebeca5ab2c65b35aa") {
      if (active !== "ALL") {
        result = result.filter((row) => {
          const branchName = branchMapping[row.receipt_branch];
          return branchName === active;
        });
      }
    } else {
      result = result.filter(
        (row) => row.receipt_branch === currentStaffFacLoc
      );
    }

    if (globalFilter) {
      const lower = globalFilter.toLowerCase();

      result = result.filter((row) => {
        const receiptNo = (row.receipt_no || "").toString().toLowerCase();
        const receiptItem = Array.isArray(row.receipt_item)
          ? row.receipt_item.join(", ").toLowerCase()
          : (row.receipt_item || "").toString().toLowerCase();

        const vendorName = (row.vendor_name || "").toString().toLowerCase();
        const staffName = (row.staff_name || "").toString().toLowerCase();
        const entryDateStr = row.entry_date
          ? new Date(row.entry_date).toLocaleDateString("en-GB").toLowerCase()
          : "";

        const poArray = Array.isArray(row.po_number)
          ? row.po_number
          : [row.po_number];

        const poMatch = poArray.some((item) =>
          item?.toString().toLowerCase().includes(lower)
        );
        return (
          receiptNo.includes(lower) ||
          receiptItem.includes(lower) ||
          vendorName.includes(lower) ||
          staffName.includes(lower) ||
          entryDateStr.includes(lower) ||
          poMatch
        );
      });
    }

    return result;
  }, [data, userRole, currentStaffFacLoc, active, globalFilter]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "entry_date",
        header: "Date",
        size: 150,
        Cell: ({ cell }) =>
          new Intl.DateTimeFormat("en-GB").format(new Date(cell.getValue())),
      },
      {
        accessorKey: "receipt_no",
        header: "Receipt No.",
        size: 10,
      },
      {
        header: "Item Name",
        accessorFn: (row) =>
          Array.isArray(row.receipt_item)
            ? row.receipt_item.join(", ")
            : row.receipt_item || "",
        size: 150,
      },

      {
        accessorKey: "po_number",
        header: "PO NO.",
        size: 150,
      },
      {
        accessorKey: "vendor_name",
        header: "PARTY",
        size: 150,
      },
      {
        accessorKey: "staff_name",
        header: "Created by",
        size: 50,
      },
      {
        accessorKey: "receipt_branch",
        header: "Receipt Branch",
        size: 50,
        Cell: ({ cell }) => {
          const branchId = cell.getValue();
          const branchName = branchMapping[branchId] || "UNKNOWN";

          return <div className="max-h-10 overflow-y-auto">{branchName}</div>;
        },
      },
      {
        accessorKey: "status",
        header: "Bill Receipt ",
        size: 80,
        Cell: ({ row }) => {
          const { status, _id, received_on } = row.original;

          const handleVerify = async () => {
            const result = await Swal.fire({
              title: "Are you sure?",
              text: !status
                ? `Do you want to verify this receipt as received?`
                : `Do you want to mark this receipt as pending?`,
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Yes, verify",
              cancelButtonText: "No",
            });

            if (result.isConfirmed) {
              try {
                await api.patch(`receipt-note/verify-received/${_id}`);
                await getData();

                Swal.fire({
                  title: "Verified!",
                  text: "Receipt has been marked as received.",
                  icon: "success",
                  timer: 2000,
                  showConfirmButton: false,
                });
              } catch (error) {
                console.error("Verification failed:", error);
                Swal.fire({
                  title: "Error!",
                  text: "Something went wrong while verifying the receipt.",
                  icon: "error",
                });
              }
            }
          };

          return (
            <div className="text-center">
              <div className="flex flex-col items-center">
                {auditor !== "PolyBond Audit"
                  && (
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        minWidth: 80,
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                        textTransform: "none",
                        backgroundColor: status === 1 ? "#16a34a" : "#3b82f6",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: status === 1 ? "#15803d" : "#2563eb",
                        },
                      }}
                      onClick={handleVerify}
                    >
                      {status === 0 ? "Pending" : "Received"}
                    </Button>
                  )}
                {status === 1 && received_on && (
                  <span className="text-[13px] font-normal opacity-90 mt-1">
                    {new Date(received_on).toLocaleDateString("en-GB")}
                  </span>
                )}
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "_id",
        header: "Action",
        size: 100,
        Cell: ({ cell }) => (
          <div className="flex items-center gap-3">
            <div onClick={() => handlePrint(cell)}>
              <button>
                <FileText size={20} />
              </button>
            </div>
            <div>
              {auditor !== "PolyBond Audit"
                && (
                  <button
                    onClick={() => {
                      const receiptId = cell.getValue();
                      localStorage.setItem("receiptId", receiptId);
                      window.open("/create-receipt-form", "_blank");
                    }}
                  >
                    <Pencil size={18} />
                  </button>
                )}
            </div>
            {auditor !== "PolyBond Audit"
              && (
                <div onClick={() => handleDelete(cell.row.original._id)}>
                  <button>
                    <Trash2 size={18} />
                  </button>
                </div>
              )}
            {cell.row.original.vendor_name === "ODYSSEY COMPUTERS" && (
              <div
                onClick={() => {
                  computerDetails(cell.row.original._id);
                }}
              >
                <button>
                  <BookText size={20} />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ],
    [month]
  );

  const table = useMaterialReactTable({
    columns,
    data: filteredData,
    enableRowSelection: true,
    getRowId: (row) => row.userId,
    onRowSelectionChange: setRowSelection,
    state: {
      rowSelection,
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,

    renderToolbarAlertBannerContent: ({ table }) => {
      return (
        <div className="flex gap-2 px-1 mt-1">
          {userRole !== "666c0f8ebeca5ab2c65b35aa"
            && (<button
              className="p-1 bg-[#EEEDEB] rounded-t-lg shadow-sm"
              onClick={exportToExcel}
            >
              <span className="text-sm">Export Excel</span>
            </button>
            )}
        </div>
      );
    },
  });

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const formatedData = [];
    const header1 = [
      "VCH",
      "VCH",
      "State Name",
      "GSTIN",
      "Customer Name",
      "Voucher",
      "Product Name",
      "Quantity",
      "Rate",
      "Disc %",
      "Amount",
      "CGST %",
      "CGST",
      "SGST %",
      "SGST",
      "IGST %",
      "IGST ",
      "TCS",
      "Refrence",
      "Refrence",
      "Stock",
      "Stock",
      "Stock",
      "Purchase",
      "Terms Of",
      "Other",
      "Terms Of",
      "Terms Of",
      "Terms Of",
      "P.O.",
      "P.O.",
      "Bill/ LR No.",
      "Motor",
      "Challan",
      "Challan",
      "Weight Slip",
      "Wt Slip",
      "Gate Entry",
      "Store",
      "Payment",
      "Narration",
    ];
    const header2 = [
      "No.",
      "Date",
      "",
      "",
      "",
      "Type",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ,
      "",
      "",
      "No.",
      "Date",
      "Desc1",
      "Desc2",
      "Desc3",
      "Ledger",
      "Payment",
      "",
      "Delievery1",
      "Delievery2",
      "Delievery3",
      "No.",
      "Date",
      "",
      "Vehicle no.",
      "No",
      "Date",
      "no.",
      "Date",
      "No.",
      "Remarks",
      "terms",
      "",
    ];

    excelData.map((row) => {
      const gstRate = parseFloat(row.receipt_item_gst) || 0;
      const baseAmount = parseFloat(row.receipt_item_total_without_gst) || 0;
      const isCG = row.vendor_gstno && row.vendor_gstno.startsWith("22");

      const halfGst = gstRate / 2;
      const halfGstAmount = baseAmount * (halfGst / 100);
      const fullGstAmount = baseAmount * (gstRate / 100);

      const vendorGst = row.vendor_gstno || "";
      const vendorCode = vendorGst.substring(0, 2);

      const gstStateCodes = [
        { code: "01", state: "Jammu & Kashmir" },
        { code: "02", state: "Himachal Pradesh" },
        { code: "03", state: "Punjab" },
        { code: "04", state: "Chandigarh" },
        { code: "05", state: "Uttarakhand" },
        { code: "06", state: "Haryana" },
        { code: "07", state: "Delhi" },
        { code: "08", state: "Rajasthan" },
        { code: "09", state: "Uttar Pradesh" },
        { code: "10", state: "Bihar" },
        { code: "11", state: "Sikkim" },
        { code: "12", state: "Arunachal Pradesh" },
        { code: "13", state: "Nagaland" },
        { code: "14", state: "Manipur" },
        { code: "15", state: "Mizoram" },
        { code: "16", state: "Tripura" },
        { code: "17", state: "Meghalaya" },
        { code: "18", state: "Assam" },
        { code: "19", state: "West Bengal" },
        { code: "20", state: "Jharkhand" },
        { code: "21", state: "Odisha" },
        { code: "22", state: "Chhattisgarh" },
        { code: "23", state: "Madhya Pradesh" },
        { code: "24", state: "Gujarat" },
        { code: "25", state: "Daman & Diu" },
        { code: "26", state: "Dadra & Nagar Haveli" },
        { code: "27", state: "Maharashtra" },
        { code: "28", state: "Andhra Pradesh (Old)" },
        { code: "29", state: "Karnataka" },
        { code: "30", state: "Goa" },
        { code: "31", state: "Lakshadweep" },
        { code: "32", state: "Kerala" },
        { code: "33", state: "Tamil Nadu" },
        { code: "34", state: "Puducherry" },
        { code: "35", state: "Andaman & Nicobar Islands" },
        { code: "36", state: "Telangana" },
        { code: "37", state: "Andhra Pradesh (New)" },
      ];
      const stateObj = gstStateCodes.find((s) => s.code === vendorCode);
      const vendorState = stateObj ? stateObj.state : " ";

      formatedData.push([
        row.receipt_no || "",
        row.entry_date
          ? row.entry_date.split("T")[0].split("-").reverse().join("-")
          : "",
        vendorState,
        row.vendor_gstno || "",
        row.vendor_name || "",
        "Receipt Note",
        row.receipt_item_name,
        row.receipt_item_qty,
        row.receipt_item_rate,
        row.receipt_item_disc || "",
        baseAmount,
        isCG ? halfGst : "",
        isCG ? halfGstAmount : "",
        isCG ? halfGst : "",
        isCG ? halfGstAmount : "",
        !isCG ? gstRate : "",
        !isCG ? fullGstAmount : "",
        "",
        row.receipt_no || "",
        row.entry_date
          ? row.entry_date.split("T")[0].split("-").reverse().join("-")
          : "",
        (row.receipt_item_remark || "")
          .split(/\r?\n/)[0]
          ?.replace(/;+$/g, "") || "",

        (row.receipt_item_remark || "")
          .split(/\r?\n/)[1]
          ?.replace(/;+$/g, "") || "",

        (row.receipt_item_remark || "")
          .split(/\r?\n/)[2]
          ?.replace(/;+$/g, "") || "",
        row.purchase_ledger_name || "",
        row.terms_of_payment || "",
        row.other_references || "",
        (row.terms_of_delivery || "")
          .replace(/\r/g, "")
          .split(";")[0]
          ?.trim() || "",
        (row.terms_of_delivery || "")
          .replace(/\r/g, "")
          .split(";")[1]
          ?.trim() || "",
        (row.terms_of_delivery || "")
          .replace(/\r/g, "")
          .split(";")[2]
          ?.trim() || "",
        row.po_number[0] || "",
        row.order_date
          ? row.order_date[0]
            ? row.order_date[0].split("T")[0].split("-").reverse().join("-")
            : ""
          : "",
        "",
        row.vehicle_no || "",
        row.challan_no || "",
        row.challan_date
          ? row.challan_date.split("T")[0].split("-").reverse().join("-")
          : "",
        row.weight_slip_no || "",
        row.weight_slip_date
          ? row.weight_slip_date.split("T")[0].split("-").reverse().join("-")
          : "",
        row.gate_entry_no || "",
        row.stores_remarks || "",
        "Credit",
        row.receipt_narration || "",
      ]);
    });

    const sheet = XLSX.utils.aoa_to_sheet([header1, header2, ...formatedData]);
    XLSX.utils.book_append_sheet(workbook, sheet, "Report");
    XLSX.writeFile(workbook, "Receipt_Note_Report.xlsx");
  };

  const addFormDetails = async (e) => {
    e.preventDefault();
    const payload = {
      vendor_id,
      receipt_id,
      items: formData,
    };
    // console.log("bey", payload);
    // return;
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you  want to Submit ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit it!",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      try {
        let response;
        if (isEditMode && partsId) {
          response = await api.patch(
            `/receipt-note/computer-parts-details/update/${partsId}`,
            payload
          );
        } else {
          response = await api.post(`/receipt-note/computer-parts`, payload);
        }

        if (response && response.status === 200) {
          Swal.fire({
            title: "Submitted!",
            text: isEditMode
              ? "Data Updated successfully!"
              : "Data Submitted successfully!",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
          setFormData([]);
          setIsModalOpen(false);
          setPartsId(null);
          setIsEditMode(false);
        }
      } catch (error) {
        console.error("Error when submitting data:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while submitting the data.",
          icon: "error",
        });
      }
    }
  };
  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const monthNum = String(now.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${monthNum}`;
    setMonth(currentMonth);
  }, []);

  useEffect(() => {
    getData();
    staffNameList();
    facLocHandler();
    assetsList();
  }, [month]);

  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div>
        <div className="bg-[#fdfdfd] border mt-4 p-2 flex flex-col md:flex-row w-full justify-between items-start md:items-center rounded-md shadow gap-4">
          <div className="flex rounded-md items-center w-1/2">
            <h2 className="font-bold text-violet-500">Receipt Note Report</h2>
          </div>
          <div className="mb-4 space-x-2">
            <input
              type="month"
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
              }}
              className="border rounded px-2 py-1"
            />
          </div>
          <div className="w-full md:w-auto">
            <div className="flex flex-wrap  gap-3">
              {buttons.map((btn) => (
                <button
                  key={btn}
                  onClick={() => setActive(btn)}
                  className={`px-6 py-1 rounded ${active === btn ? "bg-[#7C3AED] text-white" : "bg-[#EEEDEB]"
                    }`}
                >
                  <span className="text-base">{btn}</span>
                </button>
              ))}
              {userRole !== "666c0f8ebeca5ab2c65b35aa"
                && (
                  <button
                    onClick={() => {
                      localStorage.removeItem("receiptId");
                      navigation("/create-receipt-form");
                    }}
                    className={`px-6 py-1 rounded bg-[#7C3AED] text-white`}
                  >
                    <span className="text-base">Receipt Note Form</span>
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full min-h-[500px] my-2 rounded-md shadow bg-[#fdfdfd]">
        {isloading ? <Loader /> : <MaterialReactTable table={table} />}
      </div>

      {/* ///Computer Parts Data Form Modal///  */}
      <ComputerPartsForm
        isModalOpen={isModalOpen}
        staffNameDropdown={staffNameDropdown}
        assetsDropdown={assetsDropdown}
        facLocation={facLocation}
        computerDetails={computerDetails}
        isEditMode={isEditMode}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        invoice={invoice}
        selectedRow={selectedRow}
        handleDynamicChange={handleDynamicChange}
        addFormDetails={addFormDetails}
      />
    </div>
  );
};
export default ReceiptNoteReport;
